import React from 'react';

export interface TimelineStep {
  id: string;
  title: string;
  icon: React.ReactNode;
  completedIcon: React.ReactNode;
  isCompleted: boolean;
  error?: string | null;
  date?: string;
  details: React.ReactNode;
  size: 'small' | 'medium' | 'large' | 'huge';

  taskIcon?: string;
  taskName?: string;
  taskDescription?: string;
  taskButtonText?: string;
  taskClick?: () => void;
}

export interface MetricCard {
  id: string;
  title: string;
  icon: React.ReactNode;
  value: string;
  isEditable?: boolean;
  onClick?: () => void;
  type: 'editable' | 'static';
  status?: 'ok' | 'warning' | 'error';
}

export enum TeacherTimelineStepSourceURL {
  PublishingKitClaimed = 'https://buildmystory.com/resources/',
  TeacherGuide = 'https://buildmystory.com/teacher-help/#add-students',
  TeacherGuideFlyers = 'https://buildmystory.com/teacher-help/#presession-flyers',
  TeacherGuidePasswords = 'https://buildmystory.com/teacher-help/#student-passwords',
  TeacherGuideStudentLogin = 'https://buildmystory.com/teacher-help/#student-login',
  TeacherGuidePostFlyers = 'https://buildmystory.com/teacher-help/#postsession-flyers',
  TeacherGuideOrderDeadline = 'https://buildmystory.com/teacher-help/',
  TeacherGuideShipBooks = 'https://buildmystory.com/teacher-help/#ship-books',
  TeacherGuideCelebrate = 'https://buildmystory.com/teacher-help/#celebrate-authors',
  EmailTemplatePreSessionFlyers = 'https://buildmystory.com/parent-templates/#pre-sessionemailTemplate',
  EmailTemplatePostSessionFlyers = 'https://buildmystory.com/parent-templates/#post-sessionemailTemplate',
  WritingSheets = 'https://buildmystory.com/resources/',
  TeacherDeadline = '/',
}